import React, { useState, useEffect } from 'react';
import { InlineWidget } from 'react-calendly';
import { supabase } from '../supabaseClient';

const isMobile = window.innerWidth <= 768;

const BOOKING_DETAILS = {
  trial: {
    title: 'Say Ciao',
    desc: "A 30 minute chat to get to know each other! We'll talk about what you're looking for and see how I can best help you reach your goals.",
    link: 'https://calendly.com/francesca-preply/trial',
    guestOnly: true,
  },
  lezione: {
    title: 'Lezione di Italiano',
    desc: 'A full 60-minute personalized coaching session. We will dive deep into your specific goals, grammar, and conversation practice.',
    link: 'https://calendly.com/sayciao-school/lezione',
    studentOnly: true,
  },
};

export const Booking = ({ session }) => {
  const [level, setLevel] = useState(session ? 'lezione' : 'trial');
  const [accepting,         setAccepting]         = useState(true);
  const [waitlistName,      setWaitlistName]      = useState('');
  const [waitlistEmail,     setWaitlistEmail]     = useState('');
  const [waitlistMessage,   setWaitlistMessage]   = useState('');
  const [waitlistSubmitted, setWaitlistSubmitted] = useState(false);
  const [waitlistLoading,   setWaitlistLoading]   = useState(false);
  const [waitlistError,     setWaitlistError]     = useState('');


  useEffect(() => {
    setLevel(session ? 'lezione' : 'trial');
  }, [session]);

    useEffect(() => {
    supabase
      .from('settings')
      .select('accepting_students')
      .eq('id', 'global')
      .single()
      .then(({ data }) => {
        if (data) setAccepting(data.accepting_students);
      });
  }, []);

  const handleWaitlistSubmit = async (e) => {
    e.preventDefault();
    if (!waitlistEmail.trim()) return;
    setWaitlistLoading(true);
    setWaitlistError('');
    try {
          const { data: existing } = await supabase
      .from('waitlist')
      .select('id')
      .eq('email', waitlistEmail.trim().toLowerCase())
      .maybeSingle();

    if (existing) {
      setWaitlistError("You're already on the list! We'll be in touch when a spot opens.");
      return;
    }
      const { error } = await supabase.from('waitlist').insert([{
        name:    waitlistName.trim(),
        email:   waitlistEmail.trim().toLowerCase(),
        message: waitlistMessage.trim(),
      }]);
      if (error) throw error;
await supabase.from('notifications').insert([{
  student_name: waitlistName.trim() || 'Qualcuno',
  message: `[WAITLIST] ${waitlistName.trim() || 'Qualcuno'} (${waitlistEmail.trim().toLowerCase()}) si è iscritto alla lista d'attesa.${waitlistMessage.trim() ? ` "${waitlistMessage.trim()}"` : ''}`,
  is_read: false,
}]);

      setWaitlistSubmitted(true);
    } catch (err) {
      setWaitlistError('Something went wrong. Please try again.');
    } finally {
      setWaitlistLoading(false);
    }
  };

  const visibleTabs = Object.entries(BOOKING_DETAILS).filter(([, details]) => {
    if (!session && details.studentOnly) return false;
    if (session  && details.guestOnly)   return false;
    return true;
  });

  const current = BOOKING_DETAILS[level];

 if (!session && !accepting) {
    return (
      <>
        <section id="booking" style={sectionStyle}>
<div id="waitlist" style={innerStyle}>
              <p style={nudgeStyle}>Nuovi studenti</p>
            <h2 style={headingStyle}>
              LISTA <span style={italicAccentStyle}>D'ATTESA</span>
            </h2>

            <div style={{
              maxWidth: '520px', margin: '0 auto',
              backgroundColor: '#fff', borderRadius: '20px',
              padding: isMobile ? '32px 24px' : '48px 40px',
              boxShadow: '0 20px 50px rgba(40,54,24,0.06)',
              border: '1px solid rgba(188,108,37,0.12)',
              borderTop: '4px solid #BC6C25',
              textAlign: 'left',
            }}>
              {waitlistSubmitted ? (
                <div style={{ textAlign: 'center', padding: '20px 0' }}>
                  <div style={{ fontSize: '2.5rem', marginBottom: '16px' }}>🇮🇹</div>
                  <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.8rem', fontStyle: 'italic', color: '#283618', margin: '0 0 12px' }}>
                    You are on my list!
                  </h3>
                  <p style={{ fontSize: '0.82rem', color: '#3d4a2e', lineHeight: '1.7', margin: 0 }}>
                    I'll reach out personally as soon as a spot opens up! A presto!
                  </p>
                </div>
              ) : (
                <>
                  <p style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '1.3rem', fontStyle: 'italic', color: '#283618', margin: '0 0 8px', lineHeight: 1.4 }}>
                    I'm fully booked right now, but I'd love to have you.
                  </p>
                  <p style={{ fontSize: '0.78rem', color: '#3d4a2e', lineHeight: '1.7', margin: '0 0 32px', opacity: 0.8 }}>
                  Leave your details below and I'll reach out personally the moment a spot opens up.<br/>
                  No spam! Just a note from me when it's your turn.                  </p>

                  <form onSubmit={handleWaitlistSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <div>
                      <label style={formLabelStyle}>Your name</label>
                      <input
                        style={formInputStyle}
                        placeholder="e.g. Sarah"
                        value={waitlistName}
                        onChange={e => setWaitlistName(e.target.value)}
                      />
                    </div>
                    <div>
                      <label style={formLabelStyle}>Email address <span style={{ color: '#BC6C25' }}>*</span></label>
                      <input
                        type="email"
                        style={formInputStyle}
                        placeholder="your@email.com"
                        value={waitlistEmail}
                        onChange={e => setWaitlistEmail(e.target.value)}
                        required
                      />
                    </div>
                    <div>
                      <label style={formLabelStyle}>Your level & goals (optional)</label>
                      <textarea
                        style={{ ...formInputStyle, height: '80px', resize: 'none', paddingTop: '10px' }}
                        placeholder="e.g. Complete beginner, planning a trip to Italy..."
                        value={waitlistMessage}
                        onChange={e => setWaitlistMessage(e.target.value)}
                      />
                    </div>
                    {waitlistError && (
                      <p style={{ color: '#B23A3A', fontSize: '0.78rem', margin: 0 }}>{waitlistError}</p>
                    )}
                    <button
                      type="submit"
                      disabled={waitlistLoading || !waitlistEmail.trim()}
                      style={{
                        backgroundColor: '#BC6C25', color: '#fff', border: 'none',
                        padding: '14px', borderRadius: '8px', fontSize: '0.75rem',
                        fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase',
                        cursor: waitlistLoading || !waitlistEmail.trim() ? 'default' : 'pointer',
                        opacity: waitlistLoading || !waitlistEmail.trim() ? 0.4 : 1,
                        fontFamily: "'Montserrat', sans-serif",
                      }}
                    >
                      {waitlistLoading ? 'Sending...' : '✉️ Join the waitlist'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </section>

        <div style={hourVisualContainer}>
          <p style={nudgeStyle}>How we spend our 60 minutes</p>
          <h3 style={hourTitleStyle}>Every lesson is built around <em>you</em></h3>
          <div style={stepsGridStyle}>
            {[
              { num: '01', icon: '🔁', label: 'Quick Recap',       time: '~10 min', desc: 'We start by reviewing what we covered last time so nothing gets forgotten.' },
              { num: '02', icon: '🧠', label: 'New Concept',        time: '~15 min', desc: 'One new grammar point or topic: clear, simple, with real examples.' },
              { num: '03', icon: '🗣️', label: 'Real Conversation',  time: '~30 min', desc: 'We talk! I just make sure you have the right tools first.', featured: true },
              { num: '04', icon: '📝', label: 'Wrap Up',            time: '~5 min', desc: 'We recap, I assign targeted homework, and adjust the next lesson to what you need.' },
            ].map((step) => (
              <div key={step.num} style={step.featured ? featuredStepStyle : stepCardStyle}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '14px' }}>
                  <span style={step.featured ? featuredNumStyle : stepNumStyle}>{step.num}</span>
                  <span style={stepTimeStyle}>{step.time}</span>
                </div>
                <span style={stepIconStyle}>{step.icon}</span>
                <p style={step.featured ? featuredLabelStyle : stepLabelStyle}>{step.label}</p>
                <p style={step.featured ? featuredDescStyle : stepDescStyle}>{step.desc}</p>
              </div>
            ))}
          </div>
          <p style={tailorNoteStyle}>
            Not a fan of this structure? <strong>No problem.</strong> Every student is different and I'll be happy to shape the lesson around what works best for you.
          </p>
        </div>
      </>
    );
  }

  return (
    <>
      <section id="booking" style={sectionStyle}>
        <div style={innerStyle}>
          <p style={nudgeStyle}>
            {session ? 'Book your next lesson' : 'Book today — limited spots available for new students'}
          </p>
          <h2 style={headingStyle}>
            PRENOTA LA TUA <span style={italicAccentStyle}>{session ? 'LEZIONE' : 'TRIAL'}</span>
          </h2>
          <div style={menuContainer}>
            {visibleTabs.map(([key]) => (
              <button key={key} onClick={() => setLevel(key)} style={level === key ? activeTab : inactiveTab}>
                {key.toUpperCase()}
              </button>
            ))}
          </div>
          <div style={descriptionArea}>
            <h3 style={levelTitleStyle}>{current.title}</h3>
            <p style={levelDescStyle}>{current.desc}</p>
          </div>
          <div style={calendarWrapper}>
            <div style={isMobile ? calendarCropperMobile : calendarCropperDesktop}>
              <InlineWidget
                url={current.link}
                styles={{ height: isMobile ? '700px' : '900px', width: '100%', marginTop: isMobile ? '0px' : '-40px' }}
                pageSettings={{ backgroundColor: 'fcf9f2', hideEventTypeDetails: true, hideLandingPageDetails: true, primaryColor: 'bc6c25', textColor: '283618', hideGdprBanner: true }}
                utm={{ utmSource: session ? 'ReturningStudent' : 'GuestBooking' }}
              />
            </div>
          </div>
        </div>
      </section>

      <div style={hourVisualContainer}>
        <p style={nudgeStyle}>How we spend our 60 minutes</p>
        <h3 style={hourTitleStyle}>Every lesson is built around <em>you</em></h3>
        <div style={stepsGridStyle}>
          {[
            { num: '01', icon: '🔁', label: 'Quick Recap',       time: '~10 min', desc: 'We start by reviewing what we covered last time so nothing gets forgotten.' },
            { num: '02', icon: '🧠', label: 'New Concept',        time: '~15 min', desc: 'One new grammar point or topic: clear, simple, with real examples.' },
            { num: '03', icon: '🗣️', label: 'Real Conversation',  time: '~30 min', desc: 'We talk! I just make sure you have the right tools first.', featured: true },
            { num: '04', icon: '📝', label: 'Wrap Up',            time: '~5 min', desc: 'We recap, I assign targeted homework, and adjust the next lesson to what you need.' },
          ].map((step) => (
            <div key={step.num} style={step.featured ? featuredStepStyle : stepCardStyle}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '14px' }}>
                <span style={step.featured ? featuredNumStyle : stepNumStyle}>{step.num}</span>
                <span style={stepTimeStyle}>{step.time}</span>
              </div>
              <span style={stepIconStyle}>{step.icon}</span>
              <p style={step.featured ? featuredLabelStyle : stepLabelStyle}>{step.label}</p>
              <p style={step.featured ? featuredDescStyle : stepDescStyle}>{step.desc}</p>
            </div>
          ))}
        </div>
        <p style={tailorNoteStyle}>
          Not a fan of this structure? <strong>No problem.</strong> Every student is different and I'll be happy to shape the lesson around what works best for you.
        </p>
      </div>
    </>
  );
};

// ─── Styles ───────────────────────────────────────────────────────────────────
const TERRACOTTA = '#BC6C25';
const DEEP_MOSS  = '#283618';
const PAPER      = '#FCF9F2';

const formLabelStyle = { display: 'block', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '1px', color: '#3d4a2e', marginBottom: '6px', fontFamily: "'Montserrat', sans-serif", fontWeight: 700 };
const formInputStyle = { width: '100%', padding: '12px', borderRadius: '8px', border: '1px solid #eee', fontSize: '0.9rem', boxSizing: 'border-box', fontFamily: "'Montserrat', sans-serif", outline: 'none', backgroundColor: '#fafafa' };


const sectionStyle  = { backgroundColor: PAPER, padding: isMobile ? '50px 20px 30px' : '120px 20px' };
const innerStyle    = { maxWidth: '1000px', margin: '0 auto', textAlign: 'center' };

const nudgeStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.7rem',
  letterSpacing: '3px',
  color: TERRACOTTA,
  marginBottom: '25px',
  fontWeight: 600,
  textTransform: 'uppercase',
};

const headingStyle = {
  color: DEEP_MOSS,
  fontSize: '2.2rem',
  fontWeight: 300,
  fontFamily: "'Montserrat', sans-serif",
  letterSpacing: '5px',
  textTransform: 'uppercase',
  marginBottom: '40px',
};

const italicAccentStyle = { fontFamily: 'Montserrat', color: TERRACOTTA };

const menuContainer   = { display: 'flex', justifyContent: 'center', gap: '30px', marginBottom: '30px', borderBottom: '1px solid rgba(40, 54, 24, 0.1)' };
const descriptionArea = { maxWidth: '600px', margin: '0 auto 50px auto', minHeight: '100px' };

const levelTitleStyle = {
  fontFamily: "'Playfair Display', serif",
  fontStyle: 'italic',
  fontSize: '1.6rem',
  color: TERRACOTTA,
  marginBottom: '10px',
};

const levelDescStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '1rem',
  lineHeight: '1.7',
  color: DEEP_MOSS,
  opacity: 0.8,
  fontWeight: 300,
};

const tabBase = {
  background: 'none',
  border: 'none',
  padding: '15px',
  cursor: 'pointer',
  letterSpacing: '3px',
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.75rem',
  transition: 'all 0.3s ease',
  color: DEEP_MOSS,
};
const activeTab   = { ...tabBase, borderBottom: `2px solid ${TERRACOTTA}`, fontWeight: 500 };
const inactiveTab = { ...tabBase, borderBottom: '2px solid transparent', opacity: 0.3, fontWeight: 300 };

const calendarWrapper = {
  borderRadius: '15px',
  overflow: 'hidden',
  boxShadow: '0 20px 50px rgba(40, 54, 24, 0.04)',
  backgroundColor: PAPER,
  border: `1px solid rgba(188, 108, 37, 0.1)`,
};

const calendarCropperDesktop = {
  height: '720px',
  overflow: 'hidden',
  borderRadius: '0 0 15px 15px',
};

const calendarCropperMobile = {
  borderRadius: '0 0 15px 15px',
  // No overflow:hidden and no fixed height on mobile —
  // lets the full Calendly iframe render including the < back button
};

const hourVisualContainer = {
  margin: isMobile ? '0 20px 40px' : '0 auto 80px',
  maxWidth: '1000px',
  padding: isMobile ? '24px 20px' : '40px',
  backgroundColor: '#FFFFFF',
  borderRadius: '15px',
  boxShadow: '0 10px 30px rgba(40, 54, 24, 0.03)',
  border: `1px solid rgba(188, 108, 37, 0.1)`,
  textAlign: 'center',
};

const hourTitleStyle = {
  fontFamily: "'Cormorant Garamond', serif",
  fontSize: '1.6rem',
  fontWeight: 400,
  color: DEEP_MOSS,
  margin: '0 0 36px',
  fontStyle: 'italic',
};

const stepsGridStyle = {
  display: 'grid',
  gridTemplateColumns: isMobile ? '1fr 1fr' : 'repeat(4, 1fr)',
  gap: '14px',
  textAlign: 'left',
};

const stepCardStyle = {
  backgroundColor: PAPER,
  borderRadius: '14px',
  padding: '22px 18px',
  border: '1px solid rgba(188,108,37,0.1)',
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
};

const featuredStepStyle = {
  ...stepCardStyle,
  backgroundColor: TERRACOTTA,
  border: 'none',
  boxShadow: '0 8px 24px rgba(188,108,37,0.25)',
};

const stepNumStyle     = { fontSize: '0.55rem', letterSpacing: '2px', color: TERRACOTTA,   fontWeight: 700, fontFamily: "'Montserrat', sans-serif" };
const featuredNumStyle = { ...stepNumStyle, color: 'rgba(255,255,255,0.6)' };
const stepTimeStyle    = { fontSize: '0.55rem', letterSpacing: '1px', color: '#bbb',       fontWeight: 600, fontFamily: "'Montserrat', sans-serif" };
const stepIconStyle    = { fontSize: '1.4rem', margin: '4px 0' };
const stepLabelStyle   = { fontSize: '0.85rem', fontWeight: 700, color: DEEP_MOSS,         fontFamily: "'Montserrat', sans-serif", margin: 0 };
const featuredLabelStyle = { ...stepLabelStyle, color: '#fff' };
const stepDescStyle    = { fontSize: '0.72rem', color: '#888', lineHeight: '1.5',          fontFamily: "'Montserrat', sans-serif", margin: 0, fontWeight: 300 };
const featuredDescStyle = { ...stepDescStyle,   color: 'rgba(255,255,255,0.85)' };

const tailorNoteStyle = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: '0.78rem',
  color: DEEP_MOSS,
  opacity: 0.65,
  fontStyle: 'italic',
  marginTop: '24px',
  lineHeight: '1.6',
};